import type { ReadonlyBuffer } from '../types';

export function containsAt(
	haystack: ReadonlyBuffer | Readonly<Buffer>,
	needle: ReadonlyBuffer | Readonly<Buffer> | string,
	index = 0
): boolean {
	index = index < 0 ? 0 : index;

	// Check for length first
	if (index + needle.length > haystack.length) {
		return false;
	}

	needle = typeof needle === 'string' ? Buffer.from(needle, 'binary') : needle;

	return haystack.compare(needle as Buffer, 0, needle.length, index, index + needle.length) === 0;
}

export function startsWith(
	haystack: ReadonlyBuffer | Readonly<Buffer>,
	needle: ReadonlyBuffer | Readonly<Buffer> | string
): boolean {
	return containsAt(haystack, needle, 0);
}
